import type { LocationInfo } from '@/types';

export const locations: LocationInfo[] = [
  {
    id: 'laboratorio-cdmx',
    name: 'Sucursal CDMX',
    description: 'Laboratorio principal en la Ciudad de México, estratégicamente ubicado para atender proyectos del centro del país con servicios especializados en control de calidad.',
    address: 'Cda. Morelos 6, San Antonio Tecómitl, CP. 12100, Milpa Alta, CDMX',
    phone: ['55 2161-4772', '55 2594-2815'],
    certifications: ['ISO 9001:2015', 'NMX-EC-17025-IMNC-2018', 'EMA'],
  },
  {
    id: 'laboratorio-tepotzotlan',
    name: 'Sucursal Tepotzotlán',
    description: 'Situada en una de las zonas con mayor desarrollo logístico y urbano del país, LIEC Tepotzotlán garantiza la calidad de los materiales que construyen el crecimiento del centro de México.',
    address: 'Calle Mora 23. esquina con Quetzalcóatl, Pblo. San Mateo xoloc, C.P. 54600, Tepotzotlán, Estado de México',
    phone: ['55 6148-9013'],
    certifications: ['ISO 9001:2015', 'NMX-EC-17025-IMNC-2018', 'EMA'],
  },
  {
    id: 'laboratorio-san-luis-potosi',
    name: 'Sucursal San Luis Potosí',
    description: 'Ubicados en una región clave para la industria, en LIEC San Luis Potosí brindamos soporte técnico a proyectos que fortalecen la infraestructura del país.',
    address: 'Calle Homero 455 (Bodega 6), El Aguaje, C.P. 78398, San Luis Potosí, SLP',
    phone: ['44 4802-2172', '44 4920-5239'],
    certifications: ['ISO 9001:2015', 'NMX-EC-17025-IMNC-2018', 'EMA'],
  },
  {
    id: 'laboratorio-merida',
    name: 'Sucursal Mérida',
    description: 'En LIEC Mérida, impulsamos el desarrollo del sureste mexicano con soluciones técnicas confiables. Nuestro laboratorio está acreditado ante la EMA.',
    address: 'Calle 50, entre C. 25 y C 21, Zona Dorada II. C. P. 97229, Mérida, Yucatán',
    phone: ['99 9948-6356', '99 9175-5327'],
    certifications: ['ISO 9001:2015', 'NMX-EC-17025-IMNC-2018', 'EMA'],
  },
  {
    id: 'laboratorio-lerma',
    name: 'Sucursal Lerma',
    description: 'En el corazón del Valle de Toluca, LIEC Lerma ofrece servicios especializados en control de calidad de materiales. Gracias a nuestra acreditación ante la EMA, aseguramos resultados precisos.',
    address: 'La Merced el Calvario, C.P. 52006 Lerma de Villada, Estado México',
    phone: ['72 8688-3216', '72 2611-0926'],
    certifications: ['ISO 9001:2015', 'NMX-EC-17025-IMNC-2018', 'EMA'],
  },
  {
    id: 'laboratorio-tapachula',
    name: 'Sucursal Tapachula',
    description: 'En el extremo sur de México, LIEC Tapachula garantiza la calidad en los materiales que construyen el crecimiento del sureste. Con acreditación ante la EMA.',
    address: 'C. P. 30797, Tapachula, Chiapas',
    phone: ['96 2688-8924', '55 8584-9772'],
    certifications: ['ISO 9001:2015', 'EMA'],
  },
];

export const mapImage = 'https://images.unsplash.com/photo-1611273426858-450d8e3c9fce?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80';